export default __webpack_public_path__ + "static/image3-cb24f8e31a62895e8e8355df7e47df87.webp";